import { RegisterItem } from '@wearejh/m2-pwa-engine/lib/types';

import { cookieBannerInitializationEpic } from './epics/initialization.epic';
import { cookieBannerConsentEpic } from './epics/consent.epic';
import { fetchLatestScanDataEpic } from './epics/latest-scan.epic';
import { customServicesEpic } from './epics/custom-services.epic';
import { cookieBannerReducer } from './reducer';
import { cookieCleanupEpic } from './epics/cookie-cleanup.epic';

export function cookieBannerRegister(): RegisterItem {
    return {
        epics: [
            cookieBannerConsentEpic,
            cookieBannerInitializationEpic,
            cookieCleanupEpic,
            customServicesEpic,
            fetchLatestScanDataEpic,
        ],
        name: 'cookieBanner',
        reducers: {
            cookieBanner: cookieBannerReducer,
        },
    };
}
